export const getStrapiGraphqlPageQuery = (
  slug: string,
  locale: string
) => `query($status: PublicationStatus) { 
pages: pages(locale: "${locale}", status: $status, filters: {slug: {eq: "${slug}"}}) {
          contents {
            __typename
            ... on ComponentSharedBanner {
              listItems
              mainMediaBlock {
                title
                subtitle
                media {
                      url
                }
                mediaMobile {
                      url
                }
              }
                callToAction {
                  label
                  url
                  color
                }
            }
            ... on ComponentSharedCarousel {
              title
              layout
              items (pagination: { limit: 100 }) {
                title
                description
                link
                linkText
                image {
                      url
                      alternativeText
                }
              }
              CTA {
                label
                url
                color
              }
            }
            ... on ComponentSharedGrid {
              title
              subtitle
              background
              columns
              items {
                id
                caption
                title
                content
                image {
                      url
                      alternativeText
                      mime
                }
                imagePosition
                CTA {
                  label
                  url
                  color
                }
                rows
                columns
                background
                alignment
                fontSize
                padding
                contentLayout
                ctaWidth
              }
            }
            ... on ComponentSharedFeatureCards {
              title
              subtitle
              cards {
                id
                title
                image {
                      url
                      alternativeText
                }
                bullets {
                  id
                  lead
                  text
                }
              }
            }
            ... on ComponentSharedFeatureList {
              eyebrow
              title
              icon {
                url
                alternativeText
                mime
              }
              items {
                id
                title
                description
              }
            }
            ... on ComponentSharedFaqSection {
              title
              subtitle
              questions {
                question
                answer
              }
            }
            ... on ComponentSharedEventsList {
              title
              subtitle
              listType
              isDurationVisible
              isSlider
              category
              tag
              count
              CTA {
                label
                url
                color
              }
            }
            ... on ComponentSharedReviews {
              title
              subtitle
              items {
                rating
                content
                author
                date
                CTA {
                  label
                  url
                }
              }
            }
            ... on ComponentSharedText {
              title
              text
              image {
                    url
              }
              imagePosition
              cta {
                label
                url
              }
            }
            ... on ComponentSharedPricing {
              title
              subtitle
              pricingPlan {
                title
                subtitle
                highlight
                pricingFeature {
                  featureDescription
                  enabled
                }
                pricingPlanKey
                CTA {
                  label
                  url
                  color
                }
              }
            }
            ... on ComponentFooterFooterBlock {
              title
              items (pagination: { limit: 100 }) {
                label
                link
              }
            }
            ... on ComponentSharedSeo {
              metaTitle
              metaDescription
              metaImage {
                    url
              }
              keywords
            }
            ... on ComponentSharedHeroSections {
              title
              section {
                title
                description
                imagePosition
                background
                image {
                      url
                      alternativeText
                }
                cta {
                  label
                  url
                  color
                }
              }
            }
          }
    }
  }
  `

export const getStrapiDynamicPageLocalizationsQuery = (
  slug: string,
  locale: string
) => `query($status: PublicationStatus) {
pages: pages(locale: "${locale}", status: $status, filters: {slug: {eq: "${slug}"}}) {
          slug
          locale
          localizations {
            slug
            locale
          }
    }
  }
  `
